const daExtensionElement: HTMLElement | null = document.querySelector('da-extension');
if (daExtensionElement) {
  daExtensionElement.setAttribute('env', JSON.stringify(process.env));
}
